module.exports = __webpack_public_path__ + "static/media/loop-f1.319e4a94.gif";